import type { RouteObject } from "react-router-dom";

export const usefulFunctionsRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Useful functions" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { UsefulFunctionsPage } =
            await import("./useful-functions-page");
          return { Component: UsefulFunctionsPage };
        },
      },
    ],
  },
];
